import { IPlaybookTypeId } from "modules/governance/types/entities";
import { QueryEngineView } from "modules/insights/types/entities";

export const governancePrivateRoutesConstants = {
  root: {
    path: "/r/app/governance",
    href: () => "/r/app/governance"
  },
  governance_dashboard: {
    path: "/r/app/governance/dashboard",
    href: () => `/r/app/governance/dashboard`
  },
  governance_center: {
    path: "/r/app/governance/center",
    href: (projectId: string) => `/r/app/governance/center?project=${projectId}`
  },
  people_stats: {
    path: "/r/app/governance/people_stats",
    href: (projectId: string) =>
      `/r/app/governance/people_stats?project=${projectId}`
  },
  user_details: {
    path: "/r/app/governance/people_stats/:userId",
    href: (projectId: string, userId: string) =>
      `/r/app/governance/people_stats/${userId}?project=${projectId}`
  },
  playbooks: {
    path: "/r/app/governance/playbooks",
    href: (projectId: string) =>
      `/r/app/governance/playbooks?project=${projectId}`
  },
  create_playbook: {
    path: "/r/app/governance/playbooks/create",
    href: (projectId: string, type: IPlaybookTypeId) =>
      `/r/app/governance/playbooks/create?project=${projectId}&type=${type}`
  },
  edit_playbook: {
    path: "/r/app/governance/playbooks/:playbookId/edit",
    href: (projectId: string, playbookId: string) =>
      `/r/app/governance/playbooks/${playbookId}/edit?project=${projectId}`
  },
  single_playbook: {
    path: "/r/app/governance/playbooks/:playbookId",
    href: (projectId: string, playbookId: string) =>
      `/r/app/governance/playbooks/${playbookId}?project=${projectId}`
  },
  experiment_templates: {
    path: "/r/app/governance/center/experiments/templates",
    href: (projectId: string) =>
      `/r/app/governance/center/experiments/templates?project=${projectId}`
  },
  experiment_template: {
    path: "/r/app/governance/center/experiments/templates/:templateId",
    href: (projectId: string, templateId: string) =>
      `/r/app/governance/center/experiments/templates/${templateId}?project=${projectId}`
  },
  experiment_statuses: {
    path: "/r/app/governance/center/experiments/statuses",
    href: (projectId: string) =>
      `/r/app/governance/center/experiments/statuses?project=${projectId}`
  },
  experiment_settings: {
    path: "/r/app/governance/center/experiments/settings",
    href: (projectId: string) =>
      `/r/app/governance/center/experiments/settings?project=${projectId}`
  },
  reports_templates: {
    path: "/r/app/governance/center/reports/templates",
    href: (projectId: string) =>
      `/r/app/governance/center/reports/templates?project=${projectId}`
  },
  ideas_templates: {
    path: "/r/app/governance/center/ideas/templates",
    href: (projectId: string) =>
      `/r/app/governance/center/ideas/templates?project=${projectId}`
  },
  idea_template: {
    path: "/r/app/governance/center/ideas/templates/:templateId",
    href: (projectId: string, templateId: string) =>
      `/r/app/governance/center/ideas/templates/${templateId}?project=${projectId}`
  },
  ideas_settings: {
    path: "/r/app/governance/center/ideas/settings",
    href: (projectId: string) =>
      `/r/app/governance/center/ideas/settings?project=${projectId}`
  },
  research_templates: {
    path: "/r/app/governance/center/research/templates",
    href: (projectId: string) =>
      `/r/app/governance/center/research/templates?project=${projectId}`
  },
  research_template: {
    path: "/r/app/governance/center/research/templates/:templateId",
    href: (projectId: string, templateId: string) =>
      `/r/app/governance/center/research/templates/${templateId}?project=${projectId}`
  },
  research_statuses: {
    path: "/r/app/governance/center/research/statuses",
    href: (projectId: string) =>
      `/r/app/governance/center/research/statuses?project=${projectId}`
  },
  tag_settings: {
    path: "/r/app/governance/center/tags/settings",
    href: (projectId: string) =>
      `/r/app/governance/center/tags/settings?project=${projectId}`
  },
  tag_manager: {
    path: "/r/app/governance/center/tags/manager",
    href: (projectId: string) =>
      `/r/app/governance/center/tags/manager?project=${projectId}`
  },
  goals_settings: {
    path: "/r/app/governance/goals/settings",
    href: (projectId: string) =>
      `/r/app/governance/goals/settings?project=${projectId}`
  },
  goal_manager: {
    path: "/r/app/governance/goals/manager",
    href: (projectId: string) =>
      `/r/app/governance/goals/manager?project=${projectId}`
  },
  query_manager: {
    path: "/r/app/governance/query_manager",
    href: (projectId: string, selectedView?: QueryEngineView) =>
      `/r/app/governance/query_manager?project=${projectId}&view=${selectedView}`
  },
  crowdsource_template: {
    path: "/r/app/governance/center/crowdsource/template",
    href: (projectId: string) =>
      `/r/app/governance/center/crowdsource/template?project=${projectId}`
  }
} as const;
